import { render } from "./ZoneWizardZoneDetailsStep.vue?vue&type=template&id=57274fdb&scoped=true"
import script from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardZoneDetailsStep.vue?vue&type=script&lang=js"

import "./ZoneWizardZoneDetailsStep.vue?vue&type=style&index=0&id=57274fdb&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57274fdb"]])

export default __exports__